const styles = `
html.global-banner-padding {
  scroll-padding-bottom: 88px;
}

@media screen and (max-width: 767px) {
  html.global-banner-padding {
    scroll-padding-bottom: 48px;
  }
}

:focus, a:focus, button:focus {
    outline: none!important;
    box-shadow: 0 0 0 2px white, 0 0 0 4px var(--colour-role-border-focus);
}

:-moz-focusring,
a:-moz-focusring,
button:-moz-focusring,
[type="button"]:-moz-focusring,
[type="reset"]:-moz-focusring,
[type="submit"]:-moz-focusring {
    outline: none!important;
    box-shadow: 0 0 0 2px white, 0 0 0 4px var(--colour-role-border-focus);
}

.am-icon{font-family:AM-icon!important}

.am-icon-alert:before{content:"\\63";color:#231f20}
.am-icon-functional-secondary-close:before{content:"\\e90b"}
.am-icon-external-link:before{content:"\\e959"}
.am-icon-external-link-alt:before{content:"\\e95a"}

.am-modal h2,p,span,time{margin:0;padding:0;vertical-align:initial;border:0;}
.am-modal__content{position:relative;width:100%;margin:0 auto;z-index:0;max-height:100%}
.AMModal__fullContainer{z-index:1;padding-top:10px;overflow-y:scroll}
@media (max-width:767px) {.am-modal__content{width:95%}}
@media (min-width:768px) {.am-modal__content{width:825px}}
@media (max-width:767px) {.AMModal__fullContainer{max-height:100%}}
.session-extension .close-modal-button{display:none}
.session-extension .am-modal__close-container{cursor:default}
.session-extension .am-modal__content{width:650px}
@media (max-width:767px) {.session-extension .am-modal__content{width:95%}}

.superscripts-tiny {
  vertical-align: super;
  font-size: 50%;
  letter-spacing: 1px;
}

.superscripts {
  vertical-align: super;
  font-size: 60%;
}

.superscripts-legal {
  vertical-align: super;
  font-size: 70%;
}

@media (min-width: 768px) and (max-width:1140px) {
  .superscripts {
    font-size: 70%;
  }
  .superscripts-legal {
    font-size: 80%;
  }
}

@media (max-width:767px) {
  .superscripts {
    font-size: 80%;
  }
  .superscripts-legal {
    font-size: 90%;
  }
}
`;
export default styles;
